function _legend() { 
  this.renderSpectrum();
}

export default _legend;


// WEBPACK FOOTER //
// ./layouts/xy-heatmap/_spectrum.js